import React, { useState } from "react";
import { toast } from "react-toastify";
import { Box, Button, CircularProgress } from "@mui/material";

import { esignToolApi } from "../../../services/esignApi";
import { useSelector } from "react-redux";

const Footer = (props) => {
  const { currentStep, setCurrentStep, formData } = props;
  const { profileData } = useSelector((state) => state.profile);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      let payload = {
        email: profileData?.company_email,
        ...formData,
      };
      const response = await esignToolApi.updatePassword(payload);
      console.log(response);
      toast.success("Your password has been changed successfully!");
      setCurrentStep("");
    } catch (error) {
      toast.error("Password update failed. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ textAlign: "end" }}>
      <Button
        disabled={currentStep !== "verified" || loading}
        variant="contained"
        sx={{
          mt: 2,
          mr: 2,
          height: 40,
          color: "#fff",
          width: "155px",
          fontSize: "16px",
          boxShadow: "none",
          fontWeight: "500",
          borderRadius: "10px",
          background: "#185CB7",
          textTransform: "none",
          "&:hover": { background: "#185CB7" },
        }}
        onClick={handleSubmit}
      >
        {loading ? (
          <CircularProgress size={24} sx={{ color: "#fff" }} />
        ) : (
          "Update"
        )}
      </Button>
    </Box>
  );
};

export default Footer;
